import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListActions";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListActions";

export default WidgetModule;
